// TYGraphController.jsx
import React, { useEffect, useState } from "react";
import { useChartContext } from "../../../Context/ChartsContext";
import {
  downloadImage,
  months,
  getFinancialYearMonthsPassed,
} from "../../../Utilitie";
import { FaChartBar, FaChartLine } from "react-icons/fa";
import { IoIosArrowDropdown } from "react-icons/io";

const Controller = ({
  setYearDif,
  yearDif,
  setViewMonth,
  setCMonthsData,
  cMonthsData,
  chartType,
  openStates,
  setOpenStates,
  setChartType,
}) => {
  const { bestSheetDataObj, commodityWiseLObj } = useChartContext();

  const [selectedMonthSet, setSelectedMonthSet] = useState(new Set());
  const [btnClick, setBtnClick] = useState(false);
  const handleChartChange = (type) => {
    setChartType(type);
  };
  useEffect(() => {
    const cMonths = [];
    if (bestSheetDataObj?.bestSheetData) {
      bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
        cMonths.push(month.A_MONTH.toUpperCase()),
      ]);
    }
    setViewMonth(cMonths);
    setBtnClick(!btnClick);
    setCMonthsData(cMonths);
  }, [bestSheetDataObj]);
  const handleYearChange = (e) => {
    setYearDif(e.target.value);
  };
  const handleBTN = () => {
    if (btnClick) {
      const cMonths = [];
      bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
        cMonths.push(month.A_MONTH.toUpperCase()),
      ]);
      setViewMonth(cMonths);
      setCMonthsData(cMonths);
    } else {
      setViewMonth(months);
    }
    setBtnClick(!btnClick);
  };
  const toggleDropdown = (key) => {
    setOpenStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Toggle checkbox selection
  const toggleSelection = (setFunc, selectedSet, item) => {
    const newSet = new Set(selectedSet);
    if (newSet.has(item)) {
      newSet.delete(item);
    } else {
      newSet.add(item);
    }
    setFunc(newSet);
  };
  const monthPassed = getFinancialYearMonthsPassed();

  useEffect(() => {
    if (monthPassed) {
      const upperCaseArr = Array.from(monthPassed).map((str) =>
        str.toUpperCase()
      );
      setSelectedMonthSet(new Set(upperCaseArr));
    }
  }, []);
  useEffect(() => {
    const setData = Array.from(selectedMonthSet);
    setViewMonth(setData);
  }, [selectedMonthSet]);

  return (
    <div className="">
      <div
        className="d-flex align-items-center justify-content-around p-1 "
        style={{ background: "black", color: "white" }}
      >
        <div style={{ fontSize: "12px" }}>
          select last years range
          <br />
          <div className="d-flex">
            1
            <input
              className="d-flex align-items-center"
              onChange={handleYearChange}
              value={yearDif}
              type="range"
              min={1}
              max={bestSheetDataObj?.bestSheetData?.length}
            />
            {bestSheetDataObj?.bestSheetData?.length}
          </div>
        </div>
        {/* //////////////////////////////////////////////////////////////////////////// */}
        <div>
          <div
            style={{
              position: "relative",
              fontSize: 12,
              borderRadius: "5px",
            }}
          >
            <div
              className=""
              onClick={() => toggleDropdown("selectMonth")}
              style={{
                border: "1px solid #ccc",
                padding: "8px",
                cursor: "pointer",
                minWidth: "250px",
                maxHeight: "50px",
                overflow: "hidden",
                userSelect: "none",
              }}
            >
              Select months &nbsp;
              <IoIosArrowDropdown
                style={{
                  fontSize: 15,
                  transition: "transform 0.3s ease",
                  transform: openStates?.selectMonth
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                }}
              />
            </div>

            {openStates?.selectMonth && (
              <div
                className="papaDiv"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  border: "1px solid #ccc",
                  // background: "#fff",
                  zIndex: 10,
                }}
              >
                <hr className="m-0 p-0" />
                <div
                  className="row suggestion mt-1"
                  style={{
                    maxHeight: "250px",
                    minHeight: "50px",
                    overflowY: "auto",
                    color: "black",
                  }}
                >
                  {months.length > 0 ? (
                    months.map((month, index) => (
                      <div
                        key={index}
                        className="col-md-4 fade-in"
                        style={{ fontSize: "12px" }}
                      >
                        <label
                          className="ms-1 text-start"
                          style={{ display: "block", cursor: "pointer" }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedMonthSet.has(month)}
                            onChange={() =>
                              toggleSelection(
                                setSelectedMonthSet,
                                selectedMonthSet,
                                month
                              )
                            }
                          />
                          &nbsp;{month}
                        </label>
                      </div>
                    ))
                  ) : (
                    <div className="col-md-12 text-center">No items found</div>
                  )}
                </div>
                <hr className="m-0 p-0" />
                <div className="d-flex justify-content-evenly mt-1">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setSelectedMonthSet(new Set(months))}
                  >
                    Select All
                  </button>
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => setSelectedMonthSet(new Set())}
                  >
                    Clear All
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* ////////////////////////////////////////////////////////////////////////////// */}
        {/* <div className="   ">
          <div
            className="d-flex flex-column"
            style={{ minWidth: "120px", fontSize: "12px" }}
          >
            <div> switch to</div>
            <button
              onClick={handleBTN}
              style={{ fontSize: "12px" }}
              className={`btn btn-sm btn-outline-light`}
            >
              {btnClick
                ? `APR- ${cMonthsData[cMonthsData?.length - 1]} `
                : "All months "}
            </button>
          </div>
        </div> */}
        {/* ////////////////////////////////////////////////////////////////////////////// */}
        <div className="d-flex">
          <button
            className={`btn  btn-sm btn-outline-light d-flex align-item-center me-1 ${
              chartType === "bar" ? "active" : ""
            }`}
            style={{ height: "25px" }}
            onClick={() => {
              handleChartChange("bar");
            }}
          >
            <FaChartBar />
          </button>
          <button
            className={`btn  btn-sm btn-outline-light d-flex align-item-center me-1 ${
              chartType === "line" ? "active" : ""
            }`}
            style={{ height: "25px" }}
            onClick={() => {
              handleChartChange("line");
            }}
          >
            <FaChartLine />
          </button>
        </div>

        {/* <DownloadAsImage reportRef={reportRef} selectMonth={code} /> */}
      </div>
    </div>
  );
};

export default Controller;
